import { erpAxios } from '..';

const editNotifikacija = async (data) => {
  const { brojKredita } = await erpAxios.post(`/sistemskeNotifikacije/edit`, data);
  return brojKredita ? brojKredita : null;
};

export default editNotifikacija;
